import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { useTranslation } from "react-i18next";
import ArrowDownIcon from "../../assets/images/arrowDown.png";
import ArrowRightIcon from "../../assets/images/arrowRight.png";
import ArrowUpIcon from "../../assets/images/arrowUp.png";
import { useStyles } from "../../assets/jss/DriverScoreCard";
import { EventCode, ScoreTrend } from "../../config/app-globals.enum";
import { isShowEventScore } from "../../services/LocalStorageService";
import CustomAvatar from "../CustomComponents/CustomAvatar/CustomAvatar";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CorneringEventsIcon from "../../assets/images/cornering.svg";
import SpeedingEventsIcon from "../../assets/images/speeding.svg";
import BrakingEventsIcon from "../../assets/images/braking.svg";
import DistractionEventIcon from "../../assets/images/phone.svg"
import AccelerationEventIcon from "../../assets/images/acceleration.svg";

export default function DriverScoreCard(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    // const [startDate1] = React.useState(getStartDate);
    // const [endDate1] = React.useState(getEndDate);
    const [isShowSpeeding] = React.useState(isShowEventScore(EventCode.SPEEDING));
    const [isShowBraking] = React.useState(isShowEventScore(EventCode.BRAKING));
    const [isShowCornering] = React.useState(isShowEventScore(EventCode.CORNERING));
    const [isShowDistraction] = React.useState(isShowEventScore(EventCode.DRIVER_DISTRACTION));
    const [isShowAcceleration] = React.useState(isShowEventScore(EventCode.ACCELERATION));


    // const [getRBAC_UserImpersonation] = React.useState(
    //     getUserRBAC(RBAC_CODE.USER_IMPERSONATION, props)
    // );
    const [isApiFailed, setIsApiFailed] = useState(props.isApiFailed);
    const [driverDetails, setDriverDetails] = useState({
        loading: true,
        data: {
            requestedUserId: 0,
            contentActive: "",
            contentCompleted: "",
            status: "",
            praisoScore: 0,
            praisoRankTrend: 0,
            speedingScore: 0,
            brakingScore: 0,
            corneringScore: 0,
            accelerationScore: 0,
            distractionScore: 0,
        },
        driverRecordFound: true,
        driverDetailsErrorMessage: "",
    });

    const _driverGenericScoreData = {
        score: 0,
        trend: 0
    }
    const [driverGenericScoreData, setDriverGenericScoreData] = useState(_driverGenericScoreData);

    useEffect(() => {
        setDriverDetails(props.data);
        if (props.scoreType === 'ENGAGEMENT') {
            setDriverGenericScoreData({
                score: props.data.data.engagementScore,
                trend: props.data.data.engagementRankTrend
            })
        } else {
            setDriverGenericScoreData({
                score: props.data.data.praisoScore,
                trend: props.data.data.praisoRankTrend
            })
        }
    }, [props.data]);

    useEffect(() => {
        setIsApiFailed(props.isApiFailed);
    }, [props.isApiFailed]);

    // const openInImpersonationTab = () => {
    //     window.open(`/impersonation/${driverDetails.data.requestedUserId}/userdetails/${driverDetails.data.requestedUserId}`, `${(new Date()).getTime()}`);
    // }

    const getClassFromScore = (score) => {
        var result = classes.defaultHexColor;
        try {
            if (score >= 90)
                result = classes.starHexColor;
            else if (score >= 80)
                result = classes.goodHexColor;
            else if (score >= 70)
                result = classes.badHexColor;
            else if (score >= 0)
                result = classes.huglyHexColor;
        } catch (error) {
            console.error(`{getClassFromScore} score: ${score}`)
        }
        return result;
    }

    return (
        <>
            {driverDetails && driverDetails.loading && !isApiFailed && (
                <CustomPaper elevation={0} square className={classes.driverInfoCard} style={{ justifyContent: 'center' }} >
                    <CustomCircularProgress style={{ margin: "0 auto" }} />
                </CustomPaper>
            )}
            {!driverDetails.loading && !isApiFailed && (
                <CustomPaper elevation={0} square className={classes.driverInfoCard}>
                    <CustomTypography component="h1" variant="h5" className={classes.cardTitle} >
                        {props.scoreType === 'ENGAGEMENT' ? t("ENGAGEMENT_SCORE") : t("HELP_WOL_PRAISO_SCORE_TITLE")}
                    </CustomTypography>
                    {props.isExpandView ?
                        <>
                            <CustomBox className={classes.donutBoxContainer}>
                                <CircularProgressbarWithChildren value={driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null ? driverGenericScoreData.score : 0} strokeWidth={10} className={getClassFromScore(driverGenericScoreData.score)}>
                                    <CustomBox style={{ fontSize: 35, marginTop: -8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <strong>{driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null ? `${driverGenericScoreData.score}` : "0"}</strong>
                                        {driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null && driverGenericScoreData.trend === ScoreTrend.UP ? (
                                            <img src={ArrowUpIcon} className={classes.arrowUpIcon} alt="Up Arrow" />
                                        ) : driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null && driverGenericScoreData.trend === ScoreTrend.DOWN ? (
                                            <img src={ArrowDownIcon} className={classes.arrowDownIcon} alt="Equal Arrow" />
                                        ) : driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null && driverGenericScoreData.trend === ScoreTrend.NONE ? (
                                            <img src={ArrowRightIcon} className={classes.arrowRightIcon} alt="Right Arrow" />
                                        ) : null}
                                    </CustomBox>
                                </CircularProgressbarWithChildren>
                            </CustomBox>
                            {
                                props.scoreType === 'ENGAGEMENT' ?
                                    <CustomGrid container className={classes.eventsMainContainerBox}>
                                        <CustomGrid item sm={6} className={classes.eventsContainerBox}>
                                            <CustomBox className={classes.eventsContainer}>
                                                <CustomBox className={classes.cardInfo}>
                                                    {driverDetails.data.contentActive}
                                                </CustomBox>
                                                <CustomBox className={classes.eventsWrapper}>
                                                    {t('CONTENT_ACTIVE')}
                                                </CustomBox>
                                            </CustomBox>
                                        </CustomGrid>
                                        <CustomGrid item sm={6} className={classes.eventsContainerBox}>
                                            <CustomBox className={classes.eventsContainer}>
                                                <CustomBox className={classes.cardInfo}>
                                                    {driverDetails.data.contentCompleted}
                                                </CustomBox>
                                                <CustomBox className={classes.eventsWrapper}>
                                                    {t('CONTENT_COMPLETED')}
                                                </CustomBox>
                                            </CustomBox>
                                        </CustomGrid>
                                    </CustomGrid>
                                    :
                                    props.scoreType === 'PRAISO' ?
                                        <CustomGrid container justifyContent="space-between" spacing={0} className={classes.eventsPraisoScoreMainContainerBox}>
                                            {isShowSpeeding &&
                                                <CustomGrid item sm={3} className={classes.praisoEventsContainerBox}>
                                                    <CustomBox className={classes.eventsContainer}>
                                                        <CustomBox>
                                                            <img className={classes.eventsIcon} src={SpeedingEventsIcon} title={t('SPEEDING')} />
                                                        </CustomBox>
                                                        <CustomBox className={classes.cardInfo}>
                                                            {driverDetails.data.speedingScore}%
                                                        </CustomBox>
                                                    </CustomBox>
                                                </CustomGrid>}
                                            {isShowBraking &&
                                                <CustomGrid item sm={3} className={classes.eventScoreContainerBox}>
                                                    <CustomBox className={classes.eventsContainer}>
                                                        <CustomBox>
                                                            <img className={classes.eventsIcon} src={BrakingEventsIcon} title={t('BRAKING')} />
                                                        </CustomBox>
                                                        <CustomBox className={classes.cardInfo}>
                                                            {driverDetails.data.brakingScore}%
                                                        </CustomBox>
                                                    </CustomBox>
                                                </CustomGrid>}
                                            {isShowCornering &&
                                                <CustomGrid item sm={3} className={classes.eventScoreContainerBox}>
                                                    <CustomBox className={classes.eventsContainer}>
                                                        <CustomBox>
                                                            <img className={classes.eventsIcon} src={CorneringEventsIcon} title={t('CORNERING')} />
                                                        </CustomBox>
                                                        <CustomBox className={classes.cardInfo}>
                                                            {driverDetails.data.corneringScore}%
                                                        </CustomBox>

                                                    </CustomBox>
                                                </CustomGrid>}
                                            {isShowAcceleration &&
                                                <CustomGrid item sm={3} className={classes.eventScoreContainerBox}>
                                                    <CustomBox className={classes.eventsContainer}>
                                                        <CustomBox>
                                                            <img className={classes.eventsIcon} src={AccelerationEventIcon} title={t('ACCELERATION')} />
                                                        </CustomBox>
                                                        <CustomBox className={classes.cardInfo}>
                                                            {driverDetails.data.accelerationScore}%
                                                        </CustomBox>

                                                    </CustomBox>
                                                </CustomGrid>}
                                            {isShowDistraction &&
                                                <CustomGrid item sm={3} className={classes.eventScoreContainerBox}>
                                                    <CustomBox className={classes.eventsContainer}>
                                                        <CustomBox>
                                                            <img className={classes.distractionEventIcon} src={DistractionEventIcon} title={t('DISTRACTION')} />
                                                        </CustomBox>
                                                        <CustomBox className={classes.cardInfo}>
                                                            {driverDetails.data.distractionScore}%
                                                        </CustomBox>

                                                    </CustomBox>
                                                </CustomGrid>}
                                        </CustomGrid>
                                        :
                                        null
                            }
                        </>
                        :
                        <>
                            <CustomTypography component="div" variant="h5" className={classes.cardScoreText} >
                                {driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null ? `${driverGenericScoreData.score}` : "N/A"}
                                {driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null && driverGenericScoreData.trend === ScoreTrend.UP ? (
                                    <img src={ArrowUpIcon} className={classes.arrowUpIcon} alt="Up Arrow" />
                                ) : driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null && driverGenericScoreData.trend === ScoreTrend.DOWN ? (
                                    <img src={ArrowDownIcon} className={classes.arrowDownIcon} alt="Equal Arrow" />
                                ) : driverGenericScoreData.score !== undefined && driverGenericScoreData.score !== null && driverGenericScoreData.trend === ScoreTrend.NONE ? (
                                    <img src={ArrowRightIcon} className={classes.arrowRightIcon} alt="Right Arrow" />
                                ) : null}
                            </CustomTypography>
                        </>
                    }
                </CustomPaper>
            )}

            {isApiFailed && (
                <CustomPaper elevation={0} square className={classes.driverCard}>
                    <CustomAvatar className={clsx(classes.driverAvatar, classes.driverAvatarDisabled)} />
                    <CustomGrid>
                        <CustomTypography component="h1" variant="h5" className={clsx(classes.driverName, classes.driverNameApiFailed)} >
                            <CustomSkeleton animation="wave" width={120} height={50} />
                        </CustomTypography>
                        <CustomTypography component="h1" variant="h5" className={classes.driverEmail} >
                            <CustomSkeleton animation="wave" width={180} height={30} />
                        </CustomTypography>

                        <CustomGrid container spacing={0} alignItems="center" className={classes.rankingContainer} >
                            <CustomGrid item className={classes.ranking}>
                                <CustomGrid container spacing={0}>
                                    <CustomGrid item>
                                        <CustomTypography component="h1" variant="h5" className={classes.rankingText} >
                                            <CustomSkeleton animation="wave" width={70} height={40} />
                                            <span>{t("PRAISO_RANK")}</span>
                                        </CustomTypography>
                                    </CustomGrid>
                                    <CustomGrid item>
                                        <CustomTypography component="h1" variant="h5" className={classes.rankingText} >
                                            <CustomSkeleton animation="wave" width={70} height={40} />
                                            <span>{t("DRIVER_SCORE")}</span>
                                        </CustomTypography>
                                    </CustomGrid>
                                </CustomGrid>
                            </CustomGrid>
                            <CustomGrid item className={classes.ranking}>
                                <CustomGrid container spacing={0}>
                                    <CustomGrid item>
                                        <CustomTypography component="h1" variant="h5" className={classes.rankingText} >
                                            <CustomSkeleton animation="wave" width={70} height={40} />
                                            <span>{t("ENGAGEMENT_RANK")}</span>
                                        </CustomTypography>
                                    </CustomGrid>
                                    <CustomGrid item>
                                        <CustomTypography component="h1" variant="h5" className={classes.rankingText} >
                                            <CustomSkeleton animation="wave" width={70} height={40} />
                                            <span>{t("ENGAGEMENT_SCORE")}</span>
                                        </CustomTypography>
                                    </CustomGrid>
                                </CustomGrid>
                            </CustomGrid>
                            <CustomGrid item className={clsx(classes.ranking, classes.rankingLast)} >
                                <CustomGrid container spacing={0}>
                                    <CustomGrid item>
                                        <CustomTypography component="h1" variant="h5" className={classes.rankingText} >
                                            <CustomSkeleton animation="wave" width={70} height={40} />
                                            <span>{t("CONTENT_ACTIVE")}</span>
                                        </CustomTypography>
                                    </CustomGrid>
                                    <CustomGrid item>
                                        <CustomTypography component="h1" variant="h5" className={classes.rankingText} >
                                            <CustomSkeleton animation="wave" width={70} height={40} />
                                            <span>{t("CONTENT_COMPLETED")}</span>
                                        </CustomTypography>
                                    </CustomGrid>
                                </CustomGrid>
                            </CustomGrid>
                        </CustomGrid>
                    </CustomGrid>
                    <CustomTypography component="h1" variant="h5" className={classes.statusMessage} >
                        <span></span> {driverDetails.data.status}
                    </CustomTypography>
                </CustomPaper>
            )}
        </>
    );
}
